module.exports = __webpack_public_path__ + "static/media/inherit-img5.74f56cc0.png";